export class ComponentSpecification {
  jacket: JacketCoverSpecification;
  cover: JacketCoverSpecification;
  endsheet: EndsheetSpecification;
  inserts: InsertSpecification[];
  tipIns: TipInSpecification[];

  constructor() {
    this.jacket = new JacketCoverSpecification();
    this.cover = new JacketCoverSpecification();
    this.endsheet = new EndsheetSpecification();
    this.inserts = [];
    this.tipIns = [];
  }
}

export class JacketCoverSpecification {
  jacketPaper: string | undefined;
  frontColor: string | undefined;
  backColor: string | undefined;
  finishing: string | undefined;
  specialEffects: string[];

  constructor() {
    this.jacketPaper = undefined;
    this.frontColor = undefined;
    this.backColor = undefined;
    this.finishing = undefined;
    this.specialEffects = [];
  }
}

export class EndsheetSpecification {
  paper: string | undefined;
  frontColor: string | undefined;
  backColor: string | undefined;

  constructor() {
    this.paper = undefined;
    this.frontColor = undefined;
    this.backColor = undefined;
  }
}

export class InsertSpecification {
  id: number;
  pages: string | undefined;
  paper: string | undefined;
  color: string | undefined;
  specialInk: string | undefined;

  constructor(insertId: number) {
    this.id = insertId;
    this.pages = undefined;
    this.paper = undefined;
    this.color = undefined;
    this.specialInk = undefined;
  }
}

export class TipInSpecification {
  id: number;
  pages: string;
  paper: string | undefined;
  color: string | undefined;
  specialInk: string | undefined;

  constructor(insertId: number) {
    this.id = insertId;
    this.pages = "2";
    this.paper = undefined;
    this.color = undefined;
    this.specialInk = undefined;
  }
}
